import { connectedStore } from '../../store';
import view from '../../view';
import actions from '../actions';
import ejectGlobals from './eject-globals';
import isElementDetached from '../verifiers/is-element-detached';

const saveGlobals = (globalsToUpdate = []) => {
  const store = connectedStore.get();

  globalsToUpdate.forEach((global) => {
    const { id, elementId, newHTML } = global;
    const staticElement = view.accessors.getStaticElement(elementId);

    if (isElementDetached(staticElement)) {
      return;
    }

    if (newHTML) {
      store.dispatch(actions.setGlobalHTML(global.id, newHTML));
    }

    if (elementId) {
      let cloneNode = staticElement.cloneNode(true);
      cloneNode = ejectGlobals(cloneNode.firstElementChild);

      store.dispatch(actions.setGlobalHTML(id, cloneNode.outerHTML));
    }
  });
};

export default saveGlobals;
